import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Rocket, CheckCircle, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const BoostSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }
    const check = async () => {
      try {
        const res = await axios.get(`${API}/api/stripe/boost-status/${sessionId}`);
        if (res.data.status === 'active') setStatus('active');
        else setTimeout(check, 2000);
      } catch {
        setStatus('error');
      }
    };
    check();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg max-w-sm w-full p-8 text-center" data-testid="boost-success-page">
        {status === 'loading' && (
          <>
            <Loader2 className="h-12 w-12 text-purple-600 mx-auto mb-4 animate-spin" />
            <h1 className="text-xl font-bold text-gray-900 mb-2">{t('boostActivating')}</h1>
            <p className="text-sm text-gray-500">{t('boostActivatingDesc')}</p>
          </>
        )}
        {status === 'active' && (
          <>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="h-8 w-8 text-green-600" />
            </div>
            <h1 className="text-xl font-bold text-gray-900 mb-2">{t('boostActive')}</h1>
            <p className="text-sm text-gray-500 mb-6">{t('boostActiveDesc')}</p>
            <button onClick={() => navigate('/business-dashboard')}
              className="w-full py-3 bg-purple-600 text-white rounded-xl font-semibold hover:bg-purple-700 transition-colors">
              {t('backToDashboard')}
            </button>
          </>
        )}
        {status === 'error' && (
          <>
            <Rocket className="h-12 w-12 text-gray-300 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-gray-900 mb-2">{t('boostError')}</h1>
            <p className="text-sm text-gray-500 mb-6">{t('boostErrorDesc')}</p>
            <button onClick={() => navigate('/business-dashboard')}
              className="w-full py-3 bg-gray-200 text-gray-700 rounded-xl font-semibold hover:bg-gray-300 transition-colors">
              {t('backToDashboard')}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default BoostSuccess;
